var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobalinline = function SvgGlobalinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1070_4699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8Zm0 15c.522 0 1.262-.45 1.934-1.79.31-.62.57-1.394.725-2.21H5.312c.185.816.444 1.59.754 2.21C6.737 14.55 7.478 15 8 15Zm-2.866-5h5.732c.087-.631.134-1.303.134-2 0-.697-.047-1.369-.134-2H5.134A14.615 14.615 0 0 0 5 8c0 .697.047 1.369.134 2Zm5.525-5a8.384 8.384 0 0 0-.725-2.21C9.263 1.45 8.522 1 8 1s-1.263.45-1.934 1.79A9.527 9.527 0 0 0 5.313 5h5.346Zm1.188 1c.11.64.153 1.31.153 2s-.044 1.36-.153 2h2.862C14.9 9.366 15 8.694 15 8s-.1-1.366-.29-2h-2.863Zm-1.613-4.636C10.891 2.25 11.41 3.513 11.71 5h2.616a7.011 7.011 0 0 0-4.09-3.636Zm-4.468 0A7.02 7.02 0 0 0 1.674 5H4.29c.3-1.487.818-2.75 1.475-3.636ZM1 8c0 .694.101 1.366.29 2h2.835a15.906 15.906 0 0 1 0-4H1.29A7.006 7.006 0 0 0 1 8Zm13.325 3h-2.616c-.3 1.488-.818 2.75-1.475 3.634A7.003 7.003 0 0 0 14.325 11ZM4.291 11H1.674a7.013 7.013 0 0 0 4.092 3.634C5.109 13.75 4.59 12.488 4.29 11Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1070_4699"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgGlobalinline;